import { useDemoMode } from "../lib/demoMode";

/**
 * MER-291: persistent DEMO watermark for shared prospect URLs. Renders
 * a brand-styled banner across the top of the dashboard whenever
 * demoMode is on. Lives outside the routed page so it stays put as the
 * user navigates between tabs.
 */
export default function DemoBanner() {
  const demoMode = useDemoMode();
  if (!demoMode) return null;
  return (
    <div
      role="status"
      aria-label="Demo mode active"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        width: "100%",
        background: "linear-gradient(90deg, rgba(15,107,92,0.95), rgba(38,168,159,0.95))",
        color: "white",
        padding: "8px 16px",
        fontWeight: 700,
        fontSize: 14,
        letterSpacing: 2,
        textAlign: "center",
        textTransform: "uppercase",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      Demo Mode &middot; Customer / route / driver identifiers obfuscated
    </div>
  );
}
